import selectValue from 'lodash/get'

/**
 * Returns a new formValue instance, by removing errors in externalErrorList
 * where the fields have changed compared with the values of lastFormValue
 *
 * @param  {ValueRoot} nextFormValue
 * @param  {ValueRoot} lastFormValue
 * @return {ValueRoot}
 */
export default function invalidateExternalErrorList(nextFormValue, lastFormValue) {
  const externalErrorList = nextFormValue._externalErrorList.filter((error) => {
    const path = error.field.replace(/^data\./, '')
    return selectValue(lastFormValue.value, path) === selectValue(nextFormValue.value, path)
  })
  return nextFormValue.createRoot({
    params: { forceShowErrors: true },
    externalErrorList,
  })
}
